import { render } from "./NavItem.vue?vue&type=template&id=db0a77bc&bindings={\"route\":\"props\",\"show\":\"options\",\"flatten\":\"options\",\"hasChildren\":\"options\",\"childrensList\":\"options\",\"handleClick\":\"options\",\"getLabel\":\"options\"}"
import script from "./NavItem.vue?vue&type=script&lang=js"
export * from "./NavItem.vue?vue&type=script&lang=js"
script.render = render

export default script